import axios, { corsProxy } from '@/plugins/axios'

const PROXY = process.env.VUE_APP_PROXY_URI
const HOTELLINK_API_URI = process.env.VUE_APP_HOTELLINK_API_URI

function request () {
  const req = axios.create()
  return corsProxy(req, PROXY)
}

function send (username, password, secret, bookingIds) {
  const req = request()
  const params = {
    Credential: {
      Username: username,
      Password: password,
      SecretKey: secret
    },
    Request: {
      BookingIds: bookingIds
    }
  }
  return req.post(HOTELLINK_API_URI, params)
}

export default send
